module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "2stopwatch.168e76b4.svg";